import { render, staticRenderFns } from "./IndicatorForm.vue?vue&type=template&id=371503b5&scoped=true"
import script from "./IndicatorForm.vue?vue&type=script&lang=js"
export * from "./IndicatorForm.vue?vue&type=script&lang=js"
import style0 from "./IndicatorForm.vue?vue&type=style&index=0&id=371503b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371503b5",
  null
  
)

export default component.exports